import React, { useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

//Layouts
import NonAuthLayout from "@/layouts/NonAuthLayout";
import Globo_Patient_Layout from "@/layouts/AppLayout";

//routes
import { authProtectedRoutes, publicRoutes, globoPatientPublic, globoPatientProtected } from "./AllRoutes";
import { AuthProtected } from './AuthProtected';

import { useGetAccessUsersQuery } from "../api/Endpoints/Core/Security/Users";
import { hasAccess, getCurrentUser } from "../helpers/session_helper";

const Index = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const shouldFetch = getCurrentUser();
    const { data, refetch } = useGetAccessUsersQuery({}, { skip: !shouldFetch });

    const accessRights = data?.returnData?.map(({
        permissionTypeId,
        allowRead,
        allowWrite,
        allowDelete
    }) => ({
        permissionTypeId,
        allowRead,
        allowWrite,
        allowDelete
    }));

    // useEffect(() => {
    //     const publicPaths = publicRoutes.map(route => route.path);
    //     if (publicPaths.includes(location.pathname)) {
    //         return;
    //     }

    //     const tokenExpiryDate = getCurrentUser()?.tokenExpiryDate;

    //     if (!tokenExpiryDate) {
    //         navigate('/logout');
    //         return;
    //     }

    //     if (new Date(tokenExpiryDate) <= new Date()) {
    //         navigate('/logout');
    //     }
    // }, [location.pathname, navigate]);

    const filteredRoutes = (items) => {
        return items
            .filter(item => hasAccess(item.permissionTypeId, accessRights))
            .map(item => {
                const newItem = { ...item };

                if (item.subItems) {
                    newItem.subItems = filterMenu(item.subItems);
                    if (newItem.subItems.length === 0) return null;
                }

                if (item.childItems) {
                    newItem.childItems = filterMenu(item.childItems);
                    if (newItem.childItems.length === 0) return null;
                }

                return newItem;
            })
            .filter(Boolean);
    };

    return (
        <React.Fragment>
            <Routes>

                {/* ── Existing public routes (NonAuthLayout) ── */}
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <NonAuthLayout>
                                    {route.component}
                                </NonAuthLayout>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

                {/* ── Existing protected routes (VerticalLayout) ── */}
                <Route>
                    {filteredRoutes(authProtectedRoutes).map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected>
                                    {route.component}
                                </AuthProtected>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

                {/* ── MedCare public routes (walang layout) ── */}
                <Route>
                    {globoPatientPublic.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={route.component}
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

                {/* ── MedCare protected routes (MedsLayout, walang Velzon nav) ── */}
                <Route>
                    {globoPatientProtected.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected>
                                    <Globo_Patient_Layout>{route.component}</Globo_Patient_Layout>
                                </AuthProtected>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

            </Routes>
        </React.Fragment>
    );
};

export default Index;